export default __webpack_public_path__ + "static/candidates-image-error-a0445a70f5c922cc7bfbfec81df276f0.svg";